var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.932,
    height: 22.93,
    viewBox: "0 0 22.932 22.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M25.856,21.729A18.48,18.48,0,0,0,22,19.146c-1.157-.556-1.581-.544-2.4.046-.682.493-1.123.951-1.907.779a11.378,11.378,0,0,1-3.832-2.835A11.3,11.3,0,0,1,11.022,13.3c-.166-.79.292-1.226.779-1.907.59-.819.607-1.243.046-2.4a18.115,18.115,0,0,0-2.583-3.86c-.842-.842-1.031-.659-1.495-.493A8.507,8.507,0,0,0,6.4,5.371,4.129,4.129,0,0,0,4.756,7.107c-.326.7-.7,2.016,1.22,5.441a30.361,30.361,0,0,0,5.338,7.119h0l.006.006.006.006h0a30.48,30.48,0,0,0,7.119,5.338c3.425,1.924,4.737,1.546,5.441,1.22a4.059,4.059,0,0,0,1.735-1.644,8.507,8.507,0,0,0,.727-1.369C26.515,22.76,26.7,22.571,25.856,21.729Z",
    transform: "translate(-4.02 -4.043)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutline);
export default __webpack_public_path__ + "static/media/phone-outline.aff0a2653667809cc602908362c9a744.svg";
export { ForwardRef as ReactComponent };